<template>
  <div class="right-box">
    <div class="set-pass">
      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px">
        <el-form-item label="旧密码：" prop="oldPass">
          <el-input type="password" v-model="ruleForm2.oldPass" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="pass">
          <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="submit1" type="primary" @click="submitForm2('ruleForm2')">完成</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: "setPass",
    data() {
      let validateOdlPass = (rule, value, callback) => {
        if (!value || value.toString().length < 6) {
          return callback(new Error('请输入6位以上的旧密码'));
        } else {
          callback();
        }
      }
      let validatePass = (rule, value, callback) => {
        if (value === '' || value.toString().length < 6) {
          callback(new Error('请输入6位以上的密码'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      }
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm2.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }
      return {
        nav: 0,
        ruleForm2: {
          oldPass: '',
          pass: '',
          checkPass: ''
        },
        rules2: {
          oldPass: [
            {validator: validateOdlPass, trigger: 'blur'},
          ],
          pass: [
            {validator: validatePass, trigger: 'blur'},
          ],
          checkPass: [
            {validator: validatePass2, trigger: 'blur'},
          ]
        }
      }
    },
    created() {
      this.$emit('setNav', 1)
    },
    methods:{
      submitForm2(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.ruleForm2.oldPass)
            this.$api.apiMember.setPass({
              userToken:this.$store.state.user.user_token,
              userName:this.$store.state.user.user_name,
              oldPassword:this.$md5(this.ruleForm2.oldPass),
              newPassword:this.$md5(this.ruleForm2.pass),
              rnewPassword:this.$md5(this.ruleForm2.checkPass)
            })
              .then(() => {
                this.$message({
                  message: '恭喜您修改成功,请重新登录',
                  type: 'success'
                });
                setTimeout(()=>{
                  this.$store.state.user=null
                  this.$router.push('/orgLogin')
                },1000)
              })
              .catch((res) => {
                this.$message(res.info)
              })
          } else {
            return false;
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .right-box {
    padding: 30px 0;

    .set-pass {
      width: 400px;
      margin: 0 auto;

      .submit1 {
        width: 100%;
      }
    }
  }
</style>